import { FunnelConfig } from '~/utils/funnels';

export const GO_SOLAR_FUNNEL_ID = 'goSolar';

export const config: FunnelConfig = {
  id: GO_SOLAR_FUNNEL_ID,
  path: '/go-solar',
  show: () => true,
};
